import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import React from 'react';

import type { SxProps, Theme } from '@mui/material/styles';

// Define the props type
interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  sx?: SxProps<Theme>;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  open,
  onClose,
  message = "Error occurred",
  sx,
}) =><Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={sx}>
      <DialogTitle
        sx={{
          backgroundColor: "#5399DB",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Error
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", backgroundColor: "#f0f0f0" }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#5399DB",
            color: "#fff",
            textTransform: "none",
            minWidth: "100px",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>

export default ErrorDialog;
